import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';
import { ActionHistoryDetail } from '../../../common/action-history-grid/types/ActionHistoryDetail';

export const useGetPOActionHistory = (purchaseOrderID: number, enabled: boolean) => {

    const { data, isLoading } = useQuery({
        queryKey: ['po-action-history', purchaseOrderID],
        queryFn: async () => await apiClient.get('purchase-order/action-history',
            { params: { purchaseOrderID: purchaseOrderID } }) as ActionHistoryDetail[],
        enabled: enabled
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
